import { useEffect } from 'react';

export function useSEO(
  title: string,
  description: string,
  keywords: string,
  canonical: string,
  ogType: string = 'website',
  ogImage: string = '',
) {
  useEffect(() => {
    document.title = title;

    const setMeta = (attrName: string, attrValue: string, content: string) => {
      let el: HTMLMetaElement | null;
      if (attrName === 'name') {
        el = document.querySelector(`meta[name="${attrValue}"]`);
      } else {
        el = document.querySelector(`meta[property="${attrValue}"]`);
      }
      if (!el) {
        el = document.createElement('meta');
        if (attrName === 'name') {
          el.setAttribute('name', attrValue);
        } else {
          el.setAttribute('property', attrValue);
        }
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('name', 'description', description);
    setMeta('name', 'keywords', keywords);

    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = canonical;

    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:type', ogType);
    setMeta('property', 'og:url', canonical);
    setMeta('property', 'og:locale', 'zh_CN');
    setMeta('property', 'og:site_name', '火影同人本子');
    if (ogImage) {
      setMeta('property', 'og:image', ogImage);
    }

    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    if (ogImage) {
      setMeta('name', 'twitter:image', ogImage);
    }
  }, [title, description, keywords, canonical, ogType, ogImage]);
}